import React, { useState, useEffect, useCallback } from "react";
import Layout from "./Shared/Layout";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { cartCheckout, decrQuantity, deleteItem, get_cart_Data, incrQuantity } from '../redux/action';
import Summary from "./Shared/Summary";
import { API_URL } from "../_services/apiUrl";
import { decryptData } from "../_services/encDnc";
import { get } from "../_services/apiService";
import { FaPlus, FaMinus } from 'react-icons/fa';

const imageurl = process.env.REACT_APP_IMAGE_BASE_URL

const Cart = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const reduxCartData = useSelector((state) => state.cartReducer.cart);
    const [buyFormData, setBuyFormData] = useState([]);
    const [formattedTotal, setFormattedTotal] = useState('0.00');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const loginId = localStorage.getItem('loginId');
    const [userAddress, setUserAdderss] = useState([]);

    useEffect(() => {
        if (loginId) {
            const cartItems = reduxCartData.map(item => ({
                skuId: item?.skuId || 0,
                cartItemId: item.cartItemId || 0,
                productId: item.productId || 0,
                loginId: loginId ? Number(loginId) : 0,
                buyStatus: item.buyStatus || 0,
                quantity: item.quantity || 1,
                unitPrice: item.unitPrice || 0,
                totalAmount: item.unitPrice ? item.unitPrice * item.quantity : 0,
                taxId: item.taxId || 0,
                taxAmount: item.taxAmount || 0
            }));
            setBuyFormData(cartItems);
        }
    }, [loginId, reduxCartData]);

    useEffect(() => {
        if (loginId) {
            const cartTotal = buyFormData
                .filter(item => item.buyStatus === 1)
                .map(item => item.unitPrice * item.quantity)
                .reduce((preVal, curVal) => preVal + curVal, 0);

            const formatted = typeof cartTotal === 'number' ? cartTotal.toFixed(2) : '0.00';
            setFormattedTotal(formatted);

        } else {
            const cartTotal = reduxCartData
                .filter(item => item.buyStatus === 1)
                .map(item => item.unitPrice * item.quantity)
                .reduce((preVal, curVal) => preVal + curVal, 0);

            const formatted = typeof cartTotal === 'number' ? cartTotal.toFixed(2) : '0.00';
            setFormattedTotal(formatted);
        }
    }, [buyFormData, reduxCartData, loginId]);

    const handleCheckboxChange = (cartItemId) => {
        if (loginId) {
            const updatedFormData = buyFormData.map((data) =>
                data.cartItemId === cartItemId
                    ? {
                        ...data,
                        buyStatus: data.buyStatus === 1 ? 0 : 1,
                        totalAmount: data.buyStatus === 1
                            ? 0
                            : data.unitPrice * data.quantity,
                    }
                    : data
            );
            setBuyFormData(updatedFormData);
        } else {
            const updatedFormData = reduxCartData.map((data) =>
                data.cartItemId === cartItemId
                    ? {
                        ...data,
                        buyStatus: data.buyStatus === 1 ? 0 : 1,
                        totalAmount: data.buyStatus === 1
                            ? 0
                            : data.unitPrice * data.quantity,
                    }
                    : data
            );
            setBuyFormData(updatedFormData);
        }
    };

    const handleIncrementQuantity = async (item) => {
        setLoading(true)
        try {
            const updatedFormData = buyFormData.map((data) =>
                data.cartItemId === item.cartItemId
                    ? {
                        ...data,
                        quantity: data.quantity + 1,
                        totalAmount: (data.quantity + 1) * data.unitPrice,
                    }
                    : data
            );
            setBuyFormData(updatedFormData);
            await dispatch(incrQuantity(item));
        } catch (error) {
            setError('');
        } finally {
            setLoading(false)
        }
    };

    const handleDecrementQuantity = async (item) => {
        try {
            const updatedFormData = buyFormData.map((data) =>
                data.cartItemId === item.cartItemId
                    ? {
                        ...data,
                        quantity: data.quantity - 1,
                        totalAmount: (data.quantity - 1) * data.unitPrice,
                    }
                    : data
            );
            setBuyFormData(updatedFormData);
            await dispatch(decrQuantity(item));
        } catch (error) {
            setError('');
        }
    };

    const handleDeleteItem = async (item) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this item?");
        if (!isConfirmed) {
            return;
        }

        try {
            await dispatch(deleteItem(item));
        } catch (error) {
            setError('');
        }
    };

    const filteredData = reduxCartData.filter(row => row.quantity != null && row.quantity > 0);

    const getUserAddressByLoginId = useCallback(async () => {

        if (loginId) {
            setLoading(true);
            try {
                const response = await get(`${API_URL?.GetUserAddressByLoginId}?pLoginId=${loginId}`);

                const encryptedData = response.data;
                const result = decryptData(encryptedData);

                if (response.isSuccess === 200) {
                    setUserAdderss(result);
                } else {
                    setUserAdderss([]);
                }
            } catch (error) {
                setUserAdderss([]);
            } finally {
                setLoading(false);
            }
        }
    }, [loginId]);

    useEffect(() => {
        getUserAddressByLoginId();
    }, [getUserAddressByLoginId])

    const onProccedPay = async () => {
        sessionStorage.removeItem('customReqId');
        if (filteredData?.length === 0) {
            alert("No items selected! Please add items to the cart before proceeding.");
            navigate('/products')
            return;
        }

        if (parseFloat(formattedTotal) === 0) {
            alert("No items selected! Please add items to the cart before proceeding.");
            return;
        }

        if (loginId) {
            await dispatch(cartCheckout(buyFormData));
            if (userAddress != null && userAddress.length > 0) {

                localStorage.setItem('selectedAddressId', userAddress[0].addressId);
                navigate("/checkout");
            } else {
                navigate("/shipping-address");
            }
        }
        else {
            sessionStorage.setItem('priviousUrl', `/cart`);
            navigate(`/login`);
        }
        localStorage.removeItem('itemDetail');
    }

    useEffect(() => {
        dispatch(get_cart_Data());
    }, [dispatch]);

    const onProductDetail = (item) => {
        if (!item) {
            return;
        }

        localStorage.removeItem('sizeTypeName');
        localStorage.removeItem('colorTypeName');
        localStorage.removeItem('skuId');
        localStorage.removeItem('colorId');

        localStorage.setItem('productId', item?.productId);
        localStorage.setItem('productCategoryId', item?.productCategoryId);
        localStorage.setItem('productSubCategoryId', item?.productSubCategoryId);

        const categoryName = item?.categoryName?.replace(/\s+/g, '_') || '';
        const subCategoryName = item?.productSubCategoryName?.replace(/\s+/g, '_') || '';
        const productName = item?.productName?.replace(/\s+/g, '_') || '';

        navigate(`/${categoryName}/${subCategoryName}/${productName}/${item?.productId}`);
        sessionStorage.setItem('priviousUrl', `/${categoryName}/${subCategoryName}/${productName}/${item?.productId}`);
    }

    if (loading) return <div className="loading_content"><img src="./images/loading.gif" alt="Hand-stitched embroidered kurta – Gailee"/></div>;

    return (
        <Layout>
            {error ? (
                <div>{error}</div>
            ) : (
                <section className="same_space layout_main">
                    <div className="container">
                        <section className="contact-banner-sec">
                            <div className="container-fluid">
                                <div className="page-header">
                                    <h1 className="mb-3">Cart</h1>
                                </div>
                            </div>
                        </section>
                        <div className="row cart justify-content-between">
                            <div className="cart-content col-xl-8 col-md-7 col-12 pb-4">
                                {filteredData && filteredData?.length > 0 ? (
                                    filteredData?.map((item, i) => {
                                        const buyData = buyFormData.find(data => data.cartItemId === item.cartItemId);
                                        return (
                                            <div key={i}>
                                                <div className="cart-detail mb-2">
                                                    <div className="row p-sm-3 p-0">
                                                        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-3 col-12">
                                                            <div className="select_product_check_wrapper d-sm-flex align-items-center">
                                                                <div className="check_box_wrapper">
                                                                    <span>
                                                                        <input
                                                                            name="buyStatus"
                                                                            type="checkbox"
                                                                            checked={buyData?.buyStatus === 1}  // Check the corresponding buyStatus
                                                                            onChange={() => handleCheckboxChange(item.cartItemId)}
                                                                        />
                                                                    </span>
                                                                </div>
                                                                <div className="p-image ">
                                                                    {item?.productImageDtos && item.productImageDtos.length > 0 ? (
                                                                        // Check if there is an image marked as 'isHeader'
                                                                        item.productImageDtos.some(image => image.isHeader) ? (
                                                                            item.productImageDtos.map((image, j) => (
                                                                                image.isHeader ? (
                                                                                    <img
                                                                                        onClick={() => onProductDetail(item)}
                                                                                        style={{ cursor: 'pointer' }}
                                                                                        key={image.imgPath} // Using image.imgPath as a unique key
                                                                                        src={`${imageurl}${image.imgPath}`}
                                                                                        alt={`Product ${j + 1}`}
                                                                                    />
                                                                                ) : null
                                                                            ))
                                                                        ) : (
                                                                            // If no 'isHeader' image, render the first available image
                                                                            <img
                                                                                onClick={() => onProductDetail(item)}
                                                                                style={{ cursor: 'pointer' }}
                                                                                key={item.productImageDtos[0]?.imgPath}
                                                                                src={`${imageurl}${item.productImageDtos[0]?.imgPath || './images/defaultImage.png'}`}
                                                                                alt="Product"
                                                                            />
                                                                        )
                                                                    ) : (
                                                                        // If no images at all, show the default image
                                                                        <img
                                                                            onClick={() => onProductDetail(item)}
                                                                            style={{ cursor: 'pointer' }}
                                                                            key="default-image"
                                                                            src="./images/defaultImage.png"
                                                                            alt="Product unavailable"
                                                                        />
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-xxl-9 col-xl-9 col-lg-9 col-md-8 col-sm-9 col-12">
                                                            <div className="product-cart-detail ">
                                                                <h5 className="mb-md-auto mb-1 curser-pointer" onClick={() => onProductDetail(item)}>{item?.displayName}</h5>
                                                                <p className="mt-1 mb-0 display_desc_cart"
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: item?.displayDesc?.length > 80 ? `${item.displayDesc.substring(0, 80)}...` : item?.displayDesc
                                                                    }}
                                                                    title={item?.displayDesc}
                                                                />
                                                                <div className="my-1 sku_data">
                                                                    <div>
                                                                        <span className="sku_cart_heading">Color : </span>
                                                                        {item?.colorTypeName || ''}
                                                                    </div>
                                                                    <div className="mt-1">
                                                                        <span className="sku_cart_heading">Size : </span>
                                                                        <span>
                                                                            {item?.sizeTypeName || ''}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                {/* <div className="">
                                                                {item?.productSpecificationDtos?.slice(0, 2).map((element, j) => (
                                                                    <div className="my-2 ring_size" style={{ color: "#D0D0D0" }} key={j}>
                                                                        <span className="specification_heading">{element?.specificationDisplayName} : </span>
                                                                        <span className="specification_description" title={element?.description}>
                                                                            {element?.description}
                                                                        </span>
                                                                    </div>
                                                                ))}
                                                            </div> */}
                                                                <div className="d-sm-flex d-md-block d-lg-flex align-items-center count_weepr" style={{ color: "#D0D0D0", fontWeight: "600", gap: "20px" }}>
                                                                    <div className="d-flex justify-content-between align-items-center mt-2 mb-lg-auto mb-md-2 mb-sm-auto  mb-3" style={{ gap: '20px' }}>
                                                                        <div className="d-flex cart-plus-minus" >
                                                                            <span className="plus_counter" onClick={() => handleDecrementQuantity(item)} style={{ cursor: 'pointer' }}>
                                                                                <FaMinus />
                                                                            </span>
                                                                            <span>{item?.quantity}</span>
                                                                            <span className="minus_counter" onClick={() => handleIncrementQuantity(item)} disabled={loading} style={{ cursor: 'pointer' }}>
                                                                                <FaPlus />
                                                                            </span>
                                                                        </div>
                                                                        <span className="unit_price_cart">₹{item?.unitPrice}<del className="mrp_del">₹{item?.mrpPrice}</del></span>
                                                                    </div>
                                                                    <div className="cart-buttons remove_btn">
                                                                        <div className="clear" onClick={() => handleDeleteItem(item)} disabled={loading}>
                                                                            <button className="web_buttons">Remove Item</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="more_product_details mt-2">
                                                                    <span onClick={() => onProductDetail(item)}>More Details</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                    )
                                ) : (
                                    <div className="py-3">Cart is Empty</div>
                                )}
                                <div className="cart-buttons mt-sm-3 mt-3">
                                    <div className="continue">
                                        <Link to="/" title="About Gailee – Learn about our brand"><p className="web_buttons">Continue Shopping</p></Link>
                                    </div>
                                </div>
                            </div>
                            {filteredData && formattedTotal !== 0 && formattedTotal !== null ? (
                                <div className="pcard d-flex justify-content-center col-xl-4 col-md-5 col-12 mb-4">
                                    <Summary
                                        onProccedPay={onProccedPay}
                                        formattedTotal={formattedTotal}
                                    />
                                </div>
                            ) : null}
                        </div>
                    </div>

                </section>
            )}
        </Layout>
    )
}

export default Cart;